let previousListRoute = { route: 'lookbook' };

export const saveRouter = ({ route, query: parameters }) => {
  previousListRoute = { route: route.slice(1), params: parameters };
};
export const getRouter = () => previousListRoute;
